import React, { useEffect, useRef, useState } from "react";
import "./NachHistory.css";
import { nachHistories } from "../../services/merpservices";
import NachTickHist from "./NachTickHist";
import ServiceStoppedWithHover from "./ServiceStoppedWithHover";

// Module-level: keyed by glid so remounts and tab switches never re-hit the API.
const _nachHistoryCache = new Map();

const NachHistory = ({ empid, ak, glid, ecsIsActive }) => {
    const [data, setData] = useState(null);
    const fetchedGlid = useRef(null);

    const nachHisotyJson = async () => {
        try {
            const res = await nachHistories(empid, glid, ak);
            if (res?.data?.status === 200) {
                const nachData = res?.data?.data?.listing_details?.[0] || null;
                _nachHistoryCache.set(glid, nachData);
                setData(nachData);
            }
        } catch (error) {
            console.error("Error fetching Nach history:", error);
        }
    };

    useEffect(() => {
        if (!glid) return;
        if (_nachHistoryCache.has(glid)) {
            setData(_nachHistoryCache.get(glid));
            return;
        }
        if (fetchedGlid.current === glid) return;
        fetchedGlid.current = glid;
        nachHisotyJson();
    }, [glid]);

    const details = data?.nach_json?.Details;
    const serviceIds = [354, 228, 376];
    const availableServiceId = serviceIds.find((key) => details?.[key]);

    return (
        <div className="mb10">
            {availableServiceId && <NachTickHist data={data?.nach_json} />}
            {availableServiceId && (
                <ServiceStoppedWithHover dateStr={details?.[availableServiceId]?.Nach_stop_date} ecsIsActive={ecsIsActive}/>
            )}
        </div>
    );
};

export default NachHistory;